import { useEffect } from "react";

const useClickOutside = (
  ref,
  callback = () => {},
  ignoreRefs = []
) => {
  const handleClickOutside = (event) => {
    const clickedInsideMain = ref.current?.contains(event.target);

    const clickedInsideIgnored = ignoreRefs.some(
      (ignoreRef) => ignoreRef.current?.contains(event.target)
    );

    if (!clickedInsideMain && !clickedInsideIgnored) {
      callback();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, ignoreRefs, callback]);
};

export default useClickOutside;